import { toAbsoluteUrl } from "../../../../_metronic/helpers";
import { AdminDiscussionListModel } from "../../../hooks/community/models/AdminDiscussionListModel";
import { defaultProfileImage } from "../../../utils/constants";
import { CommunityAdminStatus } from "../enums/CommunityAdminStatus";
import { CommunityAdminFormatDate } from "../utils/DateTransform";

type Props = {
    list: AdminDiscussionListModel[];
    onSelect: (item: AdminDiscussionListModel) => void;
}

export const CommunityAdminTable = ({ list, onSelect }: Props) => {
    return (
        <div style={{ overflow: 'auto', height: 'fit-content' }}>
            <table className="admin-community__table">
                <thead>
                    <tr>
                        <th>ID</th>
                        <th>TITLE</th>
                        <th>NAME</th>
                        <th>TAGS</th>
                        <th>DATE CREATED</th>
                        <th>ACTIONS</th>
                    </tr>
                </thead>
                <tbody>
                    {list.map((l, i) => (
                        <tr key={i} onClick={() => onSelect(l)}>
                            <td scope="row" className="id">#{l.id}</td>
                            <td>{l.title}</td>
                            <td className="author"> 
                                <div>
                                    <img src={toAbsoluteUrl(l.authorAvatar) || defaultProfileImage} onError={(e) => { e.currentTarget.src = defaultProfileImage }}/> 
                                    <span>{l.authorName}</span>
                                </div>
                            </td>    
                            <td>{l.tags.join(', ')}</td>
                            <td>{CommunityAdminFormatDate(l.createdAt)}</td>
                            <td>{CommunityAdminStatus[l.status]}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    )
}